import React, { useState } from 'react';
import { HelpCircle } from 'react-feather';
import { useIsEnrolledUser, useIsSignedIn } from 'entity/user/userHooks';
import TierProgressCard from './TierProgressCard';
import TierBenefitCard from './TierBenefitCard';
import WhatModal from './RewardExplainModal/WhatModal';
import HowModal from './RewardExplainModal/HowModal';
import NonSignedInUserDashboard from '../RewardsContent/RewardCreditCard/NonSignedInUserDashboard';
import NonEnrolledUserDashboard from '../RewardsContent/RewardCreditCard/NonEnrolledUserDashboard';
import RewardFaq from './RewardFaq';

const RewardAboutContent = () => {
  const isSignedin = useIsSignedIn();
  const isEnrolled = useIsEnrolledUser();

  const [isWhatModalOpen, setWhatModalOpen] = useState(false);
  const [isHowModalOpen, setHowModalOpen] = useState(false);

  return (
    <div className="flex flex-col w-full pt-0 lg:pt-6 lg:w-[866px]">
      <div className="flex flex-col gap-2 w-full">
        {!isSignedin && (
          <div className="rounded-none lg:rounded-lg p-4 bg-purple-200 w-full h-fit">
            <NonSignedInUserDashboard />
          </div>
        )}
        {isSignedin && !isEnrolled && (
          <div className="rounded-none lg:rounded-lg p-4 bg-purple-200 w-full h-fit">
            <NonEnrolledUserDashboard />
          </div>
        )}
        {isEnrolled && <TierProgressCard />}
        <div className="flex flex-col lg:flex-row gap-2 w-full items-center">
          <div
            onClick={() => setWhatModalOpen(true)}
            className="p-4 bg-white rounded w-full lg:w-[433px] cursor-pointer"
          >
            <div className="flex items-center justify-between w-full">
              <p className="text-sm font-bold">
                What are Seeds, Tiers & Credits?
              </p>
              <HelpCircle />
            </div>
          </div>
          <div
            onClick={() => setHowModalOpen(true)}
            className="p-4 bg-white rounded w-full lg:w-[433px] cursor-pointer"
          >
            <div className="flex items-center justify-between w-full">
              <p className="text-sm font-bold">
                How can I earn Seeds & Credits?
              </p>
              <HelpCircle />
            </div>
          </div>
        </div>
        <TierBenefitCard />
        <RewardFaq />
      </div>
      <WhatModal isOpen={isWhatModalOpen} setModalOpen={setWhatModalOpen} />
      <HowModal isOpen={isHowModalOpen} setModalOpen={setHowModalOpen} />
    </div>
  );
};

export default RewardAboutContent;
